<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 2.35001C10.2855 2.35001 10.5462 2.51209 10.6726 2.7681L12.7381 6.9535L17.3579 7.6248C17.6404 7.66585 17.8751 7.86372 17.9633 8.13522C18.0515 8.40672 17.978 8.70476 17.7736 8.90403L14.4309 12.1628L15.2202 16.7632C15.2685 17.0445 15.1529 17.3289 14.9219 17.4967C14.691 17.6645 14.3848 17.6867 14.1321 17.5539L10 15.3823L5.86793 17.5539C5.61524 17.6867 5.30906 17.6645 5.07812 17.4967C4.84719 17.3289 4.73155 17.0445 4.77982 16.7632L5.56915 12.1628L2.22648 8.90403C2.02207 8.70476 1.94851 8.40672 2.03674 8.13522C2.12496 7.86372 2.35967 7.66585 2.64217 7.6248L7.26196 6.9535L9.32746 2.7681C9.4538 2.51209 9.71453 2.35001 10 2.35001ZM10 4.79475L8.43258 7.97091C8.32334 8.19228 8.11216 8.34571 7.86787 8.38121L4.36161 8.8907L6.89857 11.364C7.07532 11.5363 7.15596 11.7845 7.11422 12.0278L6.51518 15.5192L9.65111 13.8711C9.86955 13.7563 10.1305 13.7563 10.3489 13.8711L13.4849 15.5192L12.8858 12.0278C12.8441 11.7845 12.9247 11.5363 13.1015 11.364L15.6384 8.8907L12.1322 8.38121C11.8879 8.34571 11.6767 8.19228 11.5675 7.97091L10 4.79475Z"
            fill="currentColor"
        />
    </svg>
</template>
